<template>
  <PrestationsPage
    title_1="Les"
    title_2="épilations"
    :sections="sections"
    :images="images">
    <template #prestationFooter>
      <h2 class="section-title">
        Ayant le label “ Institut Responsable ”, merci de ramener une grande serviette pour vos épilations.
      </h2>

      <h2 class="section-title">
        Nous utilisons une résine sans colophane, basse température et naturelle,
        afin de garantir une épilation respectueuse,
        douce et efficace.
      </h2>
      <h2 class="section-title">
        Et nous appliquons un sérum anti-repousse à la fin de chaque épilation.
      </h2>
    </template>
  </PrestationsPage>
</template>

<script>
import GlobalMixin from '@/mixins/global.mixin'
import { Component } from 'vue-property-decorator'
import PrestationsPage from '@/components/PrestationsPage'

@Component({
  components: {
    PrestationsPage
  }
})

export default class Page extends GlobalMixin {

  data() {
    return {
      images: undefined,

      sections: [
        {
          title: '',
          subSections: [


            {
              title: 'Visage',
              items: [
                {
                  name: 'Lèvres',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '12€',
                    }
                  ]
                },
                {
                  name: 'Menton ou joues',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '14€',
                    }
                  ]
                },
                {
                  name: 'Sourcils',
                  alternatives: [
                    {
                      description: 'Création',
                      duration: '',
                      price: '17€',
                    },
                    {
                      description: 'Entretien',
                      duration: '',
                      price: '13€',
                    }
                  ]
                },
                {
                  name: 'Sourcils & lèvres',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '20€',
                    }
                  ]
                },
                {
                  name: 'Lèvres & menton',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '26€',
                    }
                  ]
                },
                {
                  name: 'Sourcils, Lèvres & menton',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '26€',
                    }
                  ]
                },
                {
                  name: 'Visage',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '29€',
                    }
                  ]
                }
              ]
            } ,
            {
              title: 'Corps',
              items: [
                {
                  name: 'Aisselles',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '16€',
                    }
                  ]
                },
                {
                  name: 'Maillot simple',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '16€',
                    }
                  ]
                },
                {
                  name: 'Maillot Brésilien',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '20€',
                    }
                  ]
                },
                {
                  name: 'Maillot semi-intégral',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '29€',
                    }
                  ]
                },
                {
                  name: 'Maillot intégral',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '31€',
                    }
                  ]
                },
                {
                  name: 'Fesses',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '5€',
                    }
                  ]
                },
                {
                  name: 'SIF',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '5€',
                    }
                  ]
                },
                {
                  name: '½ jambes',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '22€',
                    }
                  ]
                },
  
    
                {
                  name: 'Jambes complètes',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '33€',
                    }
                  ]
                },

                {
                  name: '½ bras',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '15€',
                    }
                  ]
                },
                {
                  name: 'Bras complèts',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '18€',
                    }
                  ]
                },
              ]
            } ,
            {
              title: 'Hommes',
              items: [
                {
                  name: 'Nez ou oreilles',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '10€',
                    }
                  ]
                },
                {
                  name: 'Sourcils',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '13,5€',
                    }
                  ]
                },
                {
                  name: 'Aisselles',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '16€',
                    }
                  ]
                },
                {
                  name: 'Bras',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '20€',
                    }
                  ]
                },
                {
                  name: 'Torse ou dos',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '31€',
                    }
                  ]
                },
                {
                  name: 'Torse & dos',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '57€',
                    }
                  ]
                },
                {
                  name: 'Jambes complètes',
                  alternatives: [
                    {
                      description: '',
                      duration: '',
                      price: '36€',
                    }
                  ]
                }
              ]
            } ,
            {
              title: 'Forfaits',
              items: [
                {
                  name: '',
                  alternatives: [
                    {
                      description: '-10% à partir de 2 zones',
                      duration: '',
                      price: '',
                    },
                    {
                      description: '-15% à partir de 3 zones',
                      duration: '',
                      price: '',
                    },

                  ]
                },
              ]
            } ,

            {
              title: 'Lumière pulsée',
              subtitle: 'Consultation et Devis GRATUIT et sur rendez-vous.',
              items: [
                {
                  name: '',
                  alternatives: [
                    {
                      description: 'La séance',
                      duration: '',
                      price: '45€ à 245€',
                    }
                  ]
                }
              ]
            } ,

              
      

          ]
        },
      ],

    }
  }

  mounted()
  {
    this.$store.commit('setPageLoadState', true)
  }





}

</script>
